module.exports = __webpack_public_path__ + "img/04-3快速交付平台.2aecec5a.png";